// extracted by mini-css-extract-plugin
module.exports = {"readMore":"style_readMore__2Ymcw","title":"style_title__KH9uq"};